import React, { useEffect, useState } from 'react';
import { Container, Button } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { SYSTEM_ID_SENIORITIES } from '../../../../core/constants';
import { getSystemById, systemActions } from '../../../../core/system';
import { forgotPasswordActions } from '../../../../core/forgotPassword/actions';
import { ResetPasswordWithTokensForm } from './ResetPasswordWithTokensForm';
import { WelcomeMessage } from '../WelcomeMessage';
import { HomeAuthFooter } from '../HomeAuthFooter';
import LoadingIndicator from '../../../components/loading-indicator';
import trueLogoText from '../../../../assets/img/logo.svg'
import { FormText } from 'reactstrap';

const ResetPasswordWithTokens = ({ seniorities, loadSystem, resetPasswordWithTokens, validateInvitationTokens, forgotPassword }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const listSeniorities = seniorities && seniorities.items;
    const [tokensValidated, setTokensValidated] = useState(false);

    // Obtener tokens de la URL
    const searchParams = new URLSearchParams(location.search);
    const accountToken = searchParams.get('account-token');
    const passwordToken = searchParams.get('password-token');
    const action = searchParams.get('action');

    useEffect(() => {
        // Validar que los tokens estén presentes
        if (!accountToken || !passwordToken || action !== 'reset-password') {
            navigate('/welcome', { replace: true });
            return;
        }

        // Validar tokens contra la API
        validateInvitationTokens({
            account_token: accountToken,
            action: action,
            password_token: passwordToken
        });
    }, [accountToken, passwordToken, action, navigate, validateInvitationTokens]);

    useEffect(() => {
        // Si la validación fue exitosa, cargar seniorities y mostrar formulario
        if (!forgotPassword.isPending && 
            forgotPassword.success && 
            forgotPassword.action === forgotPasswordActions.VALIDATE_INVITATION_TOKENS) {
            setTokensValidated(true);
            loadSystem(SYSTEM_ID_SENIORITIES);
        }

        // Si la validación falló, mostrar error
        if (!forgotPassword.isPending && 
            !forgotPassword.success && 
            forgotPassword.action === forgotPasswordActions.VALIDATE_INVITATION_TOKENS &&
            forgotPassword.message === 'Invalid or expired link') {
            // Los tokens son inválidos, redirigir o mostrar error
        }

        // Si el reset fue exitoso, redirigir
        if (!forgotPassword.isPending && forgotPassword.success && forgotPassword.action === forgotPasswordActions.RESET_PASSWORD_WITH_TOKENS) {
            navigate('/login');
        }
    }, [forgotPassword, navigate, loadSystem]);

    if (!accountToken || !passwordToken || action !== 'reset-password') {
        return null;
    }

    // Mostrar loading mientras se validan los tokens
    const isValidating = forgotPassword.isPending && forgotPassword.action === forgotPasswordActions.VALIDATE_INVITATION_TOKENS;
    const validationFailed = !forgotPassword.isPending && 
        !forgotPassword.success && 
        forgotPassword.action === forgotPasswordActions.VALIDATE_INVITATION_TOKENS &&
        forgotPassword.message === 'Invalid or expired link';

    return (
        <Container fluid="xl" className='minvh-100 px-0 px-md-3'>
            <div className="d-md-flex align-items-md-stretch justify-content-md-center minvh-100">
                <WelcomeMessage displayClass={'d-none d-md-block'} />
                <div className="col-login p-md-4 align-self-center">
                    <div className='bg-white p-4 col-login-form d-flex flex-column h-100'>
                        {isValidating && (
                            <div className="content-login mb-auto pb-4">
                                <img src={trueLogoText} alt="True Advance" className='logo mb-4' />
                                <h3 className="libre-caslon-text-regular mb-3">Validating invitation...</h3>
                                <LoadingIndicator />
                            </div>
                        )}

                        {validationFailed && (
                            <div className="content-login mb-auto pb-4">
                                <img src={trueLogoText} alt="True Advance" className='logo mb-4' />
                                <h3 className="libre-caslon-text-regular mb-3">Invalid Invitation</h3>
                                <FormText color='danger' className="mb-3">
                                    {forgotPassword.error?.message || 'The invitation link is invalid or has expired. Please contact support if you need assistance.'}
                                </FormText>
                                <Button color="green-light" className='py-2 rounded-sm' block onClick={() => navigate('/welcome')}>
                                    Go to Login
                                </Button>
                            </div>
                        )}

                        {tokensValidated && !isValidating && !validationFailed && (
                            <>
                                <div className="content-login mb-auto pb-4">
                                    <img src={trueLogoText} alt="True Advance" className='logo mb-4' />
                                    <h3 className="libre-caslon-text-regular mb-3">Create New Password</h3>
                                    <ResetPasswordWithTokensForm
                                        accountToken={accountToken}
                                        passwordToken={passwordToken}
                                        listSeniorities={listSeniorities}
                                        resetPasswordWithTokens={resetPasswordWithTokens}
                                        forgotPassword={forgotPassword}
                                    />
                                </div>
                                <HomeAuthFooter />
                            </>
                        )}
                    </div>
                </div>
            </div>
            {(forgotPassword.isPending && forgotPassword.action === forgotPasswordActions.RESET_PASSWORD_WITH_TOKENS) && <LoadingIndicator />}
        </Container>
    );
};

const mapStateToProps = (state) => {
    return {
        seniorities: getSystemById(state, SYSTEM_ID_SENIORITIES),
        forgotPassword: state.forgotPassword
    };
};

const mapDispatchToProps = {
    loadSystem: systemActions.loadSystem,
    validateInvitationTokens: forgotPasswordActions.validateInvitationTokens,
    resetPasswordWithTokens: forgotPasswordActions.resetPasswordWithTokens
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordWithTokens);

